let instance = null;
import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin'
import SmoothScroll from '../utils/SmoothScroll'
import Nav from "../components/Nav";
import Accordion from "../components/Accordion";
import HtmlVideoPlayer from "../components/HtmlVideoPlayer";
import LogoTicker from "../components/LogoTicker";
import Observer from "../components/Observer";
import BlockObserver from "../components/BlockObserver";
import Testimonial from "../components/Testimonial";
import TestimonialDetailed from "../components/TestimonialDetailed";
import TextAndMediaSlideshow from "../components/TextAndMediaSlideshow";
import NumberedCarousel from "../components/NumberedCarousel";
import loadPost from "../components/loadPosts";
import relatedArticles from "../components/relatedArticles";
import AnimatedLines from "../components/AnimatedLines";
import TeamMembers from "../components/TeamMembers";
import "../components/CookiesConsent";
import "../../../node_modules/feather-icons/dist/feather.js";

export default class App {
	constructor() {
		/**
		 * Setup Commands
		 */

		// make singleton
		if (instance) {
			return instance;
		}
		instance = this;

		// global access

		window.app = this;

		// get context

		this.getContext();

		window.addEventListener("resize", () => {
			this.getContext();
		});

		GSAP.registerPlugin(ScrollTrigger,DrawSVGPlugin)

		//
		// GET SCROLL PROGRESS
		//
		window.app.scrollTop = 0;
		window.onscroll = function (e) {
			window.app.scrollTop = window.scrollY
		}


		//
		// SETTING UP SMOOTH SCROLLING
		// 
		// this.smoother = new SmoothScroll()


		//
		// Installing Feather Icons
		//
		const feather = require('feather-icons');
		feather.replace({
			class: 'icon',
			'stroke-width': 1
		});


		/**
		 * Components
		 */

		this.observer 			= new Observer();
		this.blockObserver		= new BlockObserver( document.querySelectorAll('[data-watch="true"]') )
		this.nav 				= new Nav();
		this.loadPosts 			= new loadPost();
		this.TeamMembers		= new TeamMembers();


		this.accordions = document.querySelectorAll('[data-component="accordion"]');
		this.accordions && this.accordions.forEach((accordion)=>{
			new Accordion(accordion).init();
		})



		// this.logoticker = document.querySelectorAll('[data-component="logoticker"]');
		// this.logoticker && this.logoticker.forEach((logoticker)=>{
		// 	new LogoTicker(logoticker);
		// })



		this.textAndMediaSlideshows = document.querySelectorAll('[data-component="text-and-media-slideshow"]');
		this.textAndMediaSlideshows && this.textAndMediaSlideshows.forEach((slideshow)=>{
			new TextAndMediaSlideshow(slideshow);
		})

		this.relatedArticles = document.querySelectorAll('[data-component="related-articles"]');
		this.relatedArticles && this.relatedArticles.forEach((slideshow)=>{
			new relatedArticles(slideshow);
		})


		this.numberedCarousel = document.querySelectorAll('[data-component="numbered-carousel"]');
		this.numberedCarousel && this.numberedCarousel.forEach((slideshow)=>{
			new NumberedCarousel(slideshow);
		})



		this.testimonial = document.querySelectorAll('[data-component="testimonials"]');
		this.testimonial && this.testimonial.forEach((testimonial)=>{
			new Testimonial(testimonial);
		})


		this.testimonialDetailed = document.querySelectorAll('[data-component="testimonial-detailed"]');
		this.testimonialDetailed && this.testimonialDetailed.forEach((testimonialDetailed)=>{
			new TestimonialDetailed(testimonialDetailed);
		})



		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video)=>
		{
			let options =
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: true,
				cover: false,
			}

			if( video.classList.contains('video--autoplay') ){
				options.autoplay = true;
				options.controls = false;
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}
			
			new HtmlVideoPlayer(video, options);

		})


		this.glossaryJumpTo = document.querySelector('.glossaryJumpTo');
		if(this.glossaryJumpTo) {
			this.glossaryJumpTo.addEventListener('change', function() {
				document.querySelector('.glossary-letter--'+this.value).scrollIntoView();
			});
		}

		this.copyToClipboard = document.querySelectorAll('.copyToClipboard');
		this.copyToClipboard && this.copyToClipboard.forEach((copyToClipboard) => {
			copyToClipboard.addEventListener('click', e => {
				e.preventDefault();
				console.log(copyToClipboard.href);
				navigator.clipboard.writeText(copyToClipboard.href);
			})
		})

		let googleMap = document.getElementById('map');
		if(googleMap) {
			let map;
			let lat = googleMap.dataset.lat;
			let lng = googleMap.dataset.lng;
			async function initMap() {
				const { Map } = await google.maps.importLibrary("maps");

				map = new Map(document.getElementById("map"), {
					center: { lat: Number(lat), lng: Number(lng) },
					zoom: 14,
				});
			}

			initMap();
		}



		this.dottedLines = document.querySelectorAll('.dotted-line');
		this.dottedLines && this.dottedLines.forEach((line)=>
		{
			new AnimatedLines(line);
		})


	}
	getContext() {
		// Tells us if App is Mobile, and height of Viewport.

		if (window.matchMedia("(max-width: 1024px)").matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.location.host.includes("localhost")) {
			this.URL =
				"http://" +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				"https://" + window.location.host + `/wp-content/themes/${THEME}`;
		}

	}
}